import { AlertService } from "./../../service/alert.service";
import { DataServiceClass } from "src/app/service/DataService.service";
import {
  Component,
  HostListener,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { AuthServiceService } from "../service/auth-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Validators, FormBuilder, FormGroup } from "@angular/forms";
import { first } from "rxjs/operators";
import { JwtHelperService } from "@auth0/angular-jwt";
declare var google: any;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  @HostListener("window:load", ["$event"])
  onload(event: any) {
    this.handleGoogleSignInInitCode();
  }
  helper = new JwtHelperService();
  public loginForm: FormGroup;
  public submitted: boolean = false;
  public showPasscode: boolean = false;
  public verifyForm: FormGroup;
  public inviteParam: any;
  constructor(
    private zone: NgZone,
    private authService: AuthServiceService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private dataServiceClass: DataServiceClass,
    private alertService: AlertService
  ) {
    route.queryParamMap.subscribe((params: any) => {
      if (params.params.link) {
        this.inviteParam = params.params;
      }
    });
  }

  returnUrl: string;

  private getInviteData() {
    if (this.inviteParam === undefined) return;
    this.authService.inviteLink(this.inviteParam.link).subscribe((response) => {
      this.inviteParam.userId
        ? (response.data.userId = +this.inviteParam.userId)
        : null;
      if (response && response.data) {
        this.dataServiceClass.userMobileNumberSet = response.data.phone;
        this.dataServiceClass.userEncryptedIdSet = response.data.uuid;
        this.dataServiceClass.userDataSet = response.data;
        if (this.dataServiceClass.userMobileNumberGet != null) {
          this.verifyFormControl.username.setValue(
            this.dataServiceClass.userMobileNumberGet
          );
        }
        if (response && response.data.register) {
          this.router.navigate(["auth/register"]);
        } else if (
          response &&
          !response.data.register &&
          response.data.payment
        ) {
          this.router.navigate(["payment/register"]);
        } else {
          this.router.navigate(["auth/login-passcode"]);
        }
      }
    });
  }

  ngOnInit() {
    this.verifyForm = this.formBuilder.group({
      username: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^(\d{10}|\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/
          ),
        ],
      ],
    });
    this.getInviteData();
    this.returnUrl = this.route.snapshot.queryParams["returnUrl"] || "procric8";
  }

  get verifyFormControl() {
    return this.verifyForm.controls;
  }

  onVerifyUsername() {
    this.authService
      .verifyUsername(this.verifyFormControl.username.value)
      .pipe(first())
      .subscribe((response) => {
        this.dataServiceClass.userEncryptedIdSet = response.data.uuid;
        this.dataServiceClass.userMobileNumberSet =
          this.verifyForm.value.username;
        if (
          response &&
          response.status === "Success" &&
          response.data.validIdentity
        ) {
          this.alertService.showToast("success", "Verified Successfully");
          this.router.navigate(["auth/login-passcode"]);
        } else {
          this.alertService.showToast(
            "danger",
            "Validation Error",
            "User Not Exist!"
          );
        }
      });
  }

  handleCredentialResponse(data: any) {
    this.zone.run(() => {
      localStorage.setItem("currentUser", JSON.stringify(data));
      // this.socialLoginService.authState.next(data);
      this.authService.loginWthGoogle(data.credential).subscribe((response) => {
        if (
          response &&
          response.data &&
          response.data.user &&
          response.data.user.phone
        ) {
          this.alertService.showToast("success", "Login Successfully");
          this.router.navigate(["/procric8/"]);
        } else {
          this.alertService.showToast("success", "Login Successfully");
          this.router.navigate(["/procric8/user-profile"]);
        }
      });
      // this.router.navigate(["status-dashboard"]);
    });
  }

  private handleGoogleSignInInitCode(): void {
    google.accounts.id.initialize({
      client_id:
        "485079344909-269q918rvegvpljgouuoh7j9t55i38cs.apps.googleusercontent.com",
      callback: this.handleCredentialResponse.bind(this),
      prompt_parent_id: "g_id_onload",
      cancel_on_tap_outside: true,
    });
    google.accounts.id.renderButton(document.getElementById("buttonDiv"), {
      type: "standard",
      width: 260,
      theme: "outline",
      size: "large",
      text: "sign_in_with",
      shape: "rectangular",
      logo_alignment: "left",
    });
    google.accounts.id.prompt();
  }

  decodeToken(tkn: string): void {
    if (tkn) {
      let decodeData = {
        data: this.helper.decodeToken(tkn),
        expiry: this.helper.getTokenExpirationDate(tkn),
        isTokenExpired: this.helper.isTokenExpired(tkn),
      };
      localStorage.setItem("currentUserData", JSON.stringify(decodeData));
      console.log(decodeData);
    }
  }
}
